import { Panel, VStack, Divider } from '@components/base/layout';
import { Text } from '@components/base/display';
import type { ReactNode } from 'react';

interface ShowcaseSectionProps {
  title: string;
  description?: string;
  children: ReactNode;
}

export function ShowcaseSection({
  title,
  description,
  children,
}: Readonly<ShowcaseSectionProps>) {
  return (
    <Panel variant="outlined">
      <VStack gap={4}>
        <VStack gap={1}>
          <Text as="h3" size="base" weight="semibold">
            {title}
          </Text>
          {description && (
            <Text size="sm" color="muted">
              {description}
            </Text>
          )}
        </VStack>
        <Divider spacing={0} color="light" />
        <div>{children}</div>
      </VStack>
    </Panel>
  );
}
